import { Controller } from "@hotwired/stimulus"

// Dieser Controller setzt den Fokus in ein Textfeld/Textarea.
// Wenn Turbo per Frame oder Stream Teile des DOM austauscht, versucht es den vorherigen Fokus wieder herzustellen.
// Deshalb dieser Controller, um den Fokus nachträglich richtig zu setzen.
// Aktuell wird dieser Controller nur für Karten verwendet und der Fokus wird nur gesetzt, wenn das Textfeld leer ist.

// Connects to data-controller="autofocus"
export default class extends Controller {
	static targets = ["textField"]

	connect() {
		// Warten, bis der Knoten gerendert & sichtbar ist:
		requestAnimationFrame(() => {
			// Falls Turbo gerade Fokus rekonstruieren würde, nochmals im nächsten Frame
			requestAnimationFrame(() => {
				this.focus()
			})
		})
	}

	focus() {
		if (!this.hasTextFieldTarget) return
		const textField = this.textFieldTarget
		if (this.isEmpty()) {
			textField.focus({ preventScroll: true })
			// Cursor ans Ende setzen (optional)
			try {
				textField.selectionStart = textField.selectionEnd =
					textField.value.length
			} catch (_) {}
		}
	}

	isEmpty() {
		return this.textFieldTarget.value.trim() === ""
	}
}
